import type { Connection, PublicKey } from "@solana/web3.js";

import { confirmTransactionSignature } from "./confirmTransactionSignature.js";

export async function airdrop(
  connection: Connection,
  to: PublicKey,
  amount = 1_000_000_000,
) {
  await confirmTransactionSignature(
    connection,
    await connection.requestAirdrop(to, amount),
  );
}
